import React from 'react';
import Icon from '../../../components/AppIcon';

const CareerStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
      {stats.map((stat, index) => (
        <div 
          key={index}
          className="bg-white rounded-lg sm:rounded-xl shadow-premium border border-border p-4 sm:p-6 text-center hover-lift transition-premium"
        >
          <div className={`w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-3 sm:mb-4 rounded-lg flex items-center justify-center ${stat.bgColor}`}>
            <Icon name={stat.icon} size={20} className={`sm:w-6 sm:h-6 ${stat.iconColor}`} />
          </div>
          <div className="text-xl sm:text-2xl font-bold text-text-primary mb-1">{stat.value}</div>
          <div className="text-xs sm:text-sm text-text-secondary leading-tight">{stat.label}</div>
          {stat.growth && (
            <div className="flex items-center justify-center mt-2">
              <Icon name="TrendingUp" size={10} className="text-success mr-1 flex-shrink-0" />
              <span className="text-xs text-success font-medium">{stat.growth}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CareerStats;